module.exports = __webpack_public_path__ + "static/media/proteine_icon.c30cbdc3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/proteine_icon.svg
// module id = 154
// module chunks = 0